import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { app2020 } from '../../json/app2020';
import { app2021 } from '../../json/app2021';
import Adjudicacion from './Adjudicacion';

const AdjudicacionAnteriores = () => {
    
    const  { ciclo }  = useParams();
        
    const [
      adjudicacion, setadjudicacion
      ] = useState ( [] );

    const seladjudicacion = async () => {     
    switch (ciclo) {
      case '2020':
        setadjudicacion (app2020)
        break
      case '2021':
        setadjudicacion (app2021)
        break
            }
    }

  useEffect(() => {
    seladjudicacion();
    window.scrollTo(0, 0);

  }, [ ciclo ]);

    return(        
        <>            
            <br />
            <Adjudicacion ciclo={ciclo} adjudicacion={ adjudicacion } />
            
        </>
    )
}

export default AdjudicacionAnteriores